// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EditEntity from '../../components/CRUD/EditEntity';

const UpdateFinancialAccount = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  return (
    <EditEntity
      pageTitle="EditFinancialAccount"
      fetchApiUrl="/api/v1/web_portal/settlements/financial-accounts/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      additionalApis={[
        {
          name: 'organisation',
          url: (mainData) => `/api/v1/organisations/${mainData.organisation_id}`,
          method: 'GET',
          dataPath: 'data',
          onSuccess: (orgData, mainData) => {
            mainData.organisation_en_name = orgData.data.en_name;
            mainData.organisation_ar_name = orgData.data.ar_name;
          },
        },
      ]}
      inputs={[
        {
          name: 'organisation_name',
          labelKey: 'Organisation',
          inputType: 'text',
          required: false,
          disabled: true,
          useLanguageValue: true,
          enKey: 'organisation_en_name',
          arKey: 'organisation_ar_name',
        },
        {
          name: 'organisation_id',
          inputType: 'hidden',
        },
        {
          name: 'name',
          labelKey: 'Name',
          inputType: 'text',
          required: true,
        },
        {
          name: 'account_number',
          labelKey: 'AccountNumber',
          inputType: 'text',
          required: true,
        },
        {
          name: 'description',
          labelKey: 'Description',
          inputType: 'text',
          required: false,
        },
        {
          name: 'balance',
          labelKey: 'Balance',
          inputType: 'number',
          required: false,
        },
      ]}
      dropdowns={[
        {
          name: 'financial_account_type_id',
          labelKey: 'AccountType',
          required: true,
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-account-types`,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueKey: 'id',
            labelKey: 'type_en',
            labelKeyAr: 'type_ar',
          },
        },
        {
          name: 'parent_account_id',
          labelKey: 'ParentAccount',
          required: false,
          dependsOn: 'organisation_id',
          apiUrl: (formValues) => 
            `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-accounts?organisation_id=${formValues.organisation_id}`,
          apiMethod: 'GET',
          dataPath: 'data.data.financialAccounts',
          optionConfig: {
            valueKey: 'id',
            labelKey: 'name',
            labelKeyAr: 'name',
          },
          includeNoneOption: false,
          filterOptions: (options, entityData, intl) => {
            if (!entityData || !entityData.id) return options;
            
            // Filter out the current account from the list
            const currentAccountId = entityData.id;
            const filteredOptions = options.filter(opt => opt.id !== currentAccountId);
            
            // Add "My Account" option at the beginning with current account's ID
            return [
              { 
                id: currentAccountId, 
                name: intl.formatMessage({ id: 'MyAccount' })
              },
              ...filteredOptions
            ];
          },
        },
      ]}
      updateApiUrl="/api/v1/web_portal/settlements/financial-accounts/:id"
      updateApiMethod="PATCH"
      buildUpdatePayload={(formValues, params, entityData) => {
        console.log('[UpdateFinancialAccount] buildUpdatePayload - formValues:', formValues);
        console.log('[UpdateFinancialAccount] buildUpdatePayload - entityData:', entityData);
        
        const payload = {
          name: formValues.name?.trim(),
          account_number: formValues.account_number?.trim(),
          description: formValues.description?.trim() || '',
          financial_account_type_id: formValues.financial_account_type_id,
          balance: formValues.balance || '0.00',
        };

        // Only include parent_account_id if it's selected and not empty
        if (formValues.parent_account_id && formValues.parent_account_id !== '') {
          payload.parent_account_id = formValues.parent_account_id;
        }

        console.log('[UpdateFinancialAccount] Final payload:', payload);
        return payload;
      }}
      backUrl="/settlements/FinancialAccounts/:id"
      successMessage="UpdatedSuccessfully"
      updateButtonLabel="update"
    />
  );
};

export default UpdateFinancialAccount;
